import { closePopup } from './custom-popup';

function productFormAjax(){
  $('form[action="/cart/add"]').on('submit', function(e) {
    e.preventDefault();
    const $form = $(this);
    let serilizeData = $form.serialize();

    if ($form.hasClass('form-popup-tag')) {
      serilizeData = serilizeData + "&" + $('.main-add-form').serialize();
    }

    $.ajax({
      url: $form.attr('action'),
      type: 'POST',
      data: serilizeData,
    })
    .done(function(data) {
      const $cartHTML = $(data).find('.mobile-cart');
      $('.cart-reaveal').addClass('reveal').empty().append($cartHTML.html());
      closePopup('.custom-popup', 300, true);
    })
    
  })
}

export default productFormAjax();



// WEBPACK FOOTER //
// ../markup/assets/js/product-form-ajax.js